<template>
  <div>
    <VTextField
      :value="e4Config.improvementInitiative.client.name"
      :label="$t('forms.labels.client')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.site.name"
      :label="$t('forms.labels.site')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.massBalanceName"
      :label="$t('forms.labels.massBalanceName')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.projectName"
      :label="$t('forms.labels.projectName')"
      outlined
      readonly
    />

    <VTextarea
      :value="e4Config.improvementInitiative.projectDescription"
      :label="$t('forms.labels.projectDescription')"
      outlined
      :rules="{ required: false, max: 500 }"
      type="text"
      readonly
    />

    <VSelect
      v-model="e4Config.improvementInitiative.waterSavingsUnit"
      :label="$t('massBalance.e4Form.improvementInitiative.waterSavingsUnit')"
      outlined
      :items="waterSavingsUnits"
      readonly
    />


    <div
      style="margin-top: 40px; margin-bottom: 40px;"
    />


    <v-row>
      <v-col
        cols="8"
      >
        <VTextField
          v-model="e4Config.coolingOperatingParameters.hot.temperatureValue"
          :label="$t('massBalance.e4Form.labels.temperatureHot')"
          type="number"
          outlined
          readonly
        />
      </v-col>
      <v-col>
        <VTextField
          v-model="e4Config.coolingOperatingParameters.temperatureUnit"
          :label="$t('massBalance.e4Form.labels.unit')"
          :items="temperatureUnits"
          outlined
          readonly
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.hot.network"
          :label="$t('massBalance.e4Form.labels.network')"
          :items="e4Config.coolingOperatingParameters.networksList"
          type="number"
          outlined
          readonly
        />
      </v-col>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.hot.component"
          :label="$t('massBalance.e4Form.labels.component')"
          :items="e4Config.coolingOperatingParameters.hotComponentsList"
          outlined
          readonly
        />
      </v-col>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.hot.analysis"
          :label="$t('massBalance.e4Form.labels.analysis')"
          :items="e4Config.coolingOperatingParameters.hotAnalysisList"
          outlined
          readonly
        />
      </v-col>
    </v-row>

    <div
      style="border-top: 3px solid #9e9e9e; width: 100%; height: 1px; margin-bottom: 20px;"
    />

    <v-row>
      <v-col
        cols="8"
      >
        <VTextField
          v-model="e4Config.coolingOperatingParameters.cold.temperatureValue"
          :label="$t('massBalance.e4Form.labels.temperatureCold')"
          outlined
          type="number"
          readonly
        />
      </v-col>
      <v-col>
        <VTextField
          v-model="e4Config.coolingOperatingParameters.temperatureUnit"
          :label="$t('massBalance.e4Form.labels.unit')"
          :items="temperatureUnits"
          outlined
          readonly
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.cold.network"
          :label="$t('massBalance.e4Form.labels.network')"
          :items="e4Config.coolingOperatingParameters.networksList"
          type="number"
          outlined
          readonly
        />
      </v-col>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.cold.component"
          :label="$t('massBalance.e4Form.labels.component')"
          :items="e4Config.coolingOperatingParameters.coldComponentsList"
          outlined
          readonly
        />
      </v-col>
      <v-col>
        <VSelect
          v-model="e4Config.coolingOperatingParameters.cold.analysis"
          :label="$t('massBalance.e4Form.labels.analysis')"
          :items="e4Config.coolingOperatingParameters.coldAnalysisList"
          outlined
          readonly
        />
      </v-col>
    </v-row>

    <div
      style="margin-top: 40px; margin-bottom: 40px;"
    />

    <v-container
      v-if="e4Config.baselineData.waterSavingBaselineOption"
      style="background-color: red;padding: 0px;"
      fluid
      fillWidth
    >
      <v-table
        height="300px"
        fixedHeader
        class="baselineData__table"
      >
        <thead>
          <tr
            style="background-color:#26384B; color: white; height: 40px;"
          >
            <th
              width="200"
              style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
            >
              {{ $t('massBalance.savings') }}
            </th>
            <th
              width="900"
              style="font-weight: 400;"
            >
              {{ $t('massBalance.waterSavingsBaseline') }}
            </th>
          </tr>
        </thead>
      </v-table>
    </v-container>
    <!--  le  tableau de données en dessous du masterTitre -->
    <v-container
      v-if="e4Config.baselineData.waterSavingBaselineOption"

      style="padding: 0px;"
      fluid
      fillWidth
    >
      <v-table
        height="300"
        fixedHeader
        class="baselineData__table"
        style="overflow-y: auto;"
      >
        <thead>
          <tr
            style="height: 50px;"
          >
            <th
              width="200"
              style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white; "
              class="baselineData__table__cell"
            />
            <th
              width="450"
              class="baselineData__table__cell"
            >
              {{ firstColumnTitle() }}
            </th>
            <th
              width="450"
              class="baselineData__table__cell"
            >
              {{ secondColumnTitle() }}
            </th>
          </tr>
        </thead>
        <tbody
          style="max-height: 50px !important;"
        >
          <tr>
            <td
              class="baselineData__table__cell"
            >
              {{ $t('massBalance.reportUnit') }}
            </td>
            <td>
              <div
                style="width: 30%; display: inline-block;"
              >
                <VSelect
                  v-model="e4Config.baselineData.reportUnit.firstColumn"
                  :items="firstColumnList"
                  :outlined="false"
                  readonly
                />
              </div>
            </td>
            <td>
              <div
                style="width: 30%; display: inline-block;"
              >
                <VSelect
                  v-model="e4Config.baselineData.reportUnit.secondColumn"
                  :items="secondColumnList"
                  :outlined="false"
                  :disabled="e4Config.baselineData.waterSavingBaselineOption === 'makeUpAndCycles'
                    || e4Config.baselineData.waterSavingBaselineOption === 'blowdownAndCycles'"
                  readonly
                />
              </div>
            </td>
          </tr>
          <tr
            v-for="(i, index) in e4Config.baselineData.numberOfperiods"
            :key="i"
            style="text-align: center; "
          >
            <td
              style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
              class="baselineData__table__cell"
            >
              {{ $t(`massBalance.e4Form.months.${e4Config.baselineData.periodsMonths[index].startDate}`) }}
              {{ e4Config.baselineData.period !== 'monthly'
                ? ` - ${$t(`massBalance.e4Form.months.${e4Config.baselineData.periodsMonths[index].endDate}`)}`
                : ''
              }}
            </td>
            <td
              style="font-weight: 400; border:  0px 0px 1px 0px solid black"
            >
              <div
                style="width: 30%; display: inline-block;"
              >
                <VTextField
                  v-model="e4Config.baselineData.periodsMonths[index].firstColumn"
                  :outlined="false"
                  readonly
                />
              </div>
            </td>
            <td
              style="font-weight: 400; border: 0px 1px 0px 0px solid black"
            >
              <div
                style="width: 30%; display: inline-block;"
              >
                <VTextField
                  v-model="e4Config.baselineData.periodsMonths[index].secondColumn"
                  :outlined="false"
                  readonly
                />
              </div>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { WATER_SAVINGS_UNITS, FEED_WATER_TEMPERATURE_UNITS, WATER_SAVING_REPORT_UNITS } from '@/aquassist-shared/constants/massBalance';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'Summary',

    components: {
        VSelect,
        VTextarea,
        VTextField,
    },

    computed: {
        ...mapGetters(['e4Config']),
        waterSavingsUnits() {
            return Object.values(WATER_SAVINGS_UNITS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.units.${item}`),
            }));
        },
        temperatureUnits() {
            const units = FEED_WATER_TEMPERATURE_UNITS.map(unit => ({
                name: `°${unit}`,
                id: unit,
            }));
            return units;
        },
        secondColumnList() {
            if (this.e4Config.baselineData.waterSavingBaselineOption === 'makeUpAndCycles' || this.e4Config.baselineData.waterSavingBaselineOption === 'blowdownAndCycles') {
                return [{ id: 'cycle', name: 'Cycle' }];
            } if (this.e4Config.baselineData.waterSavingBaselineOption === 'makeUpAndBlowdown') {
                return WATER_SAVING_REPORT_UNITS.map(value => ({ id: value, name: value }));
            }
            return [];
        },
        firstColumnList() {
            return WATER_SAVING_REPORT_UNITS.map(value => ({ id: value, name: value }));
        },

    },
    methods: {
        firstColumnTitle() {
            switch (this.e4Config.baselineData.waterSavingBaselineOption) {
                case 'makeUpAndCycles':
                    return this.$t('massBalance.makeUpBaseline');
                case 'blowdownAndCycles':
                    return this.$t('massBalance.blowdownBaseline');
                case 'makeUpAndBlowdown':
                    return this.$t('massBalance.makeUpBaseline');
                default:
                    return '';
            }
        },
        secondColumnTitle() {
            switch (this.e4Config.baselineData.waterSavingBaselineOption) {
                case 'makeUpAndCycles':
                    return this.$t('massBalance.cycleBaseline');
                case 'blowdownAndCycles':
                    return this.$t('massBalance.cycleBaseline');
                case 'makeUpAndBlowdown':
                    return this.$t('massBalance.blowdownBaseline');
                default:
                    return '';
            }
        },
    },

};
</script>
